import React from 'react';
import { motion } from 'framer-motion';

function CompareImage() {
  const [pos, setPos] = React.useState(50);

  const updateFromClientX = (clientX, element) => {
    const rect = element.getBoundingClientRect();
    const x = clientX - rect.left;
    const pct = Math.max(0, Math.min(100, (x / rect.width) * 100));
    setPos(pct);
  };

  return (
    <div style={{ width: '100%' }}>
      <div
        onMouseMove={(e) => updateFromClientX(e.clientX, e.currentTarget)}
        onTouchMove={(e) => updateFromClientX(e.touches[0].clientX, e.currentTarget)}
        style={{
          position: 'relative',
          borderRadius: 24,
          overflow: 'hidden',
          border: '1px solid rgba(255,255,255,0.12)',
          boxShadow: '0 25px 70px rgba(0,0,0,0.45)',
          cursor: 'ew-resize',
          background: '#000'
        }}
      >
        <img src="/sem-grafico.png" alt="Sem gráfico" draggable="false" style={{ width: '100%', height: 330, objectFit: 'contain', display: 'block' }} />

        <img
          src="/com-grafico.png"
          alt="Com gráfico"
          draggable="false"
          style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            clipPath: `inset(0 ${100 - pos}% 0 0)`
          }}
        />

        <div style={{
          position: 'absolute',
          top: 0,
          left: `${pos}%`,
          width: 3,
          height: '100%',
          background: '#22d3ee',
          boxShadow: '0 0 20px #22d3ee',
          transform: 'translateX(-1px)'
        }} />

        <div style={{
          position: 'absolute',
          top: '50%',
          left: `${pos}%`,
          transform: 'translate(-50%, -50%)',
          width: 52,
          height: 52,
          borderRadius: '50%',
          background: '#22d3ee',
          color: '#020617',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 900,
          boxShadow: '0 0 28px rgba(34,211,238,0.8)'
        }}>
          ↔
        </div>
      </div>

      <p style={{ color: '#94a3b8', fontSize: 13, textAlign: 'center' }}>
        Arraste para comparar com e sem gráfico.
      </p>
    </div>
  );
}

export default function App() {
  const [activeDemo, setActiveDemo] = React.useState('emulador');

  const products = [
    {
      id: 'grafico',
      titulo: 'Gráfico Massinha AMD',
      preco: 5,
      destaque: 'Mais vendido',
      lastlink: 'https://lastlink.com/p/CE932AEB0/checkout-payment/',
      img1: 'https://images.unsplash.com/photo-1542751371-adc38448a05e?auto=format&fit=crop&w=1000&q=80',
      beneficios: ['Visual mais limpo', 'Config leve', 'Fácil de aplicar'],
    },
    {
      id: 'emulador',
      titulo: 'Sensibilidade Emulador',
      preco: 9.99,
      destaque: 'Premium',
      lastlink: 'https://lastlink.com/p/CCF839CDD/checkout-payment/',
      img1: 'https://images.unsplash.com/photo-1511882150382-421056c89033?auto=format&fit=crop&w=1000&q=80',
      beneficios: ['Ajuste otimizado', 'Mais controle', 'Config pronta'],
    },
    {
      id: 'celular',
      titulo: 'Sensibilidade Celular',
      preco: 5,
      destaque: 'Mobile',
      lastlink: 'https://lastlink.com/p/C213E3FA3/checkout-payment/',
      img1: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?auto=format&fit=crop&w=1000&q=80',
      beneficios: ['Boa para toque', 'Setup rápido', 'Mais precisão'],
    }
  ];

  const productAtual = activeDemo === 'emulador' ? products[1] : products[2];
  const grafico = products[0];

  const styles = {
    page: {
      minHeight: '100vh',
      background: 'radial-gradient(circle at top left, #172554, #020617 55%, #000 100%)',
      color: '#fff',
      fontFamily: 'Inter, Arial, sans-serif',
      overflowX: 'hidden'
    },
    wrap: { maxWidth: 1200, margin: '0 auto', padding: 24 },
    hero: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
      gap: 28,
      alignItems: 'center',
      padding: '36px 0 20px'
    },
    badge: {
      display: 'inline-block',
      padding: '8px 14px',
      borderRadius: 999,
      background: 'rgba(34,211,238,0.12)',
      color: '#67e8f9',
      fontWeight: 900,
      border: '1px solid rgba(34,211,238,0.25)',
      marginBottom: 14
    },
    title: {
      fontSize: 'clamp(34px,6vw,64px)',
      lineHeight: 1,
      fontWeight: 950,
      margin: 0,
      background: 'linear-gradient(90deg,#22d3ee,#a78bfa,#fb923c)',
      WebkitBackgroundClip: 'text',
      color: 'transparent'
    },
    desc: { color: '#cbd5e1', fontSize: 18, lineHeight: 1.6, marginTop: 18 },
    heroBtns: { display: 'flex', flexWrap: 'wrap', gap: 12, marginTop: 24 },
    primary: {
      display: 'inline-block',
      padding: '15px 20px',
      borderRadius: 16,
      background: 'linear-gradient(135deg,#22d3ee,#6366f1)',
      color: '#020617',
      fontWeight: 950,
      textDecoration: 'none',
      boxShadow: '0 0 30px rgba(34,211,238,0.35)'
    },
    secondary: {
      display: 'inline-block',
      padding: '15px 20px',
      borderRadius: 16,
      background: 'rgba(255,255,255,0.06)',
      color: '#fff',
      fontWeight: 850,
      textDecoration: 'none',
      border: '1px solid rgba(255,255,255,0.12)'
    },
    videoCard: {
      background: 'linear-gradient(180deg,#0f172a,#020617)',
      borderRadius: 28,
      padding: 14,
      border: '1px solid rgba(255,255,255,0.10)',
      boxShadow: '0 25px 80px rgba(0,0,0,0.45)'
    },
    tabs: { display: 'flex', gap: 10, marginBottom: 12 },
    tab: { flex: 1, padding: 12, borderRadius: 14, border: 'none', fontWeight: 900, cursor: 'pointer' },
    iframeBox: { position: 'relative', width: '100%', paddingTop: '100%', borderRadius: 18, overflow: 'hidden', background: '#000' },
    offerCard: {
      background: 'rgba(34,211,238,0.08)',
      border: '1px solid rgba(34,211,238,0.18)',
      borderRadius: 24,
      padding: 20
    },
    sectionTitle: { textAlign: 'center', fontSize: 32, fontWeight: 950, margin: '46px 0 20px' },
    grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(280px,1fr))', gap: 20 },
    card: {
      background: 'linear-gradient(180deg,#0f172a,#020617)',
      border: '1px solid rgba(255,255,255,0.08)',
      borderRadius: 24,
      overflow: 'hidden',
      boxShadow: '0 18px 45px rgba(0,0,0,0.3)'
    },
    img: { width: '100%', height: 210, objectFit: 'cover', display: 'block' },
    body: { padding: 18 },
    tag: {
      display: 'inline-block',
      padding: '6px 10px',
      borderRadius: 999,
      background: 'rgba(249,115,22,0.14)',
      color: '#fdba74',
      fontSize: 12,
      fontWeight: 900,
      marginBottom: 10
    },
    productTitle: { fontSize: 24, fontWeight: 950, margin: '0 0 8px' },
    price: { fontSize: 34, fontWeight: 950, color: '#22d3ee', marginBottom: 8 },
    list: { color: '#cbd5e1', lineHeight: 1.8, paddingLeft: 18 },
    buy: {
      display: 'block',
      textAlign: 'center',
      marginTop: 14,
      padding: 14,
      borderRadius: 15,
      background: 'linear-gradient(135deg,#22d3ee,#a78bfa)',
      color: '#020617',
      fontWeight: 950,
      textDecoration: 'none',
      boxShadow: '0 0 26px rgba(34,211,238,0.35)'
    },
    proof: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(230px,1fr))', gap: 14 },
    proofBox: {
      background: 'rgba(15,23,42,0.86)',
      border: '1px solid rgba(255,255,255,0.08)',
      borderRadius: 20,
      padding: 16,
      textAlign: 'center'
    },
    graphSection: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
      gap: 24,
      alignItems: 'center',
      background: 'linear-gradient(180deg, rgba(15,23,42,0.72), rgba(2,6,23,0.92))',
      border: '1px solid rgba(255,255,255,0.08)',
      borderRadius: 30,
      padding: 20,
      boxShadow: '0 25px 70px rgba(0,0,0,0.35)'
    },
    graphInfo: {
      background: 'rgba(34,211,238,0.08)',
      border: '1px solid rgba(34,211,238,0.18)',
      borderRadius: 24,
      padding: 22
    },
    footer: { textAlign: 'center', color: '#64748b', padding: '30px 0 10px' }
  };

  const ProductCard = ({ produto }) => (
    <motion.div whileHover={{ y: -6, scale: 1.01 }} transition={{ duration: 0.25 }} style={styles.card}>
      <img src={produto.img1} alt={produto.titulo} style={styles.img} />

      <div style={styles.body}>
        <span style={styles.tag}>{produto.destaque}</span>
        <h3 style={styles.productTitle}>{produto.titulo}</h3>
        <div style={styles.price}>R$ {produto.preco.toFixed(2).replace('.', ',')}</div>

        <ul style={styles.list}>
          {produto.beneficios.map((b, i) => <li key={i}>{b}</li>)}
        </ul>

        <a href={produto.lastlink} target="_blank" rel="noreferrer" style={styles.buy}>
          Comprar agora
        </a>
      </div>
    </motion.div>
  );

  return (
    <div style={styles.page}>
      <div style={styles.wrap}>
        <section style={styles.hero}>
          <div>
            <span style={styles.badge}>🔥 Entrega automática pela Lastlink</span>

            <motion.h1 animate={{ y: [0, -4, 0] }} transition={{ repeat: Infinity, duration: 3 }} style={styles.title}>
              Melhore sua gameplay com configs prontas
            </motion.h1>

            <p style={styles.desc}>
              Sensibilidade para emulador, mobile e gráfico massinha AMD com compra rápida,
              checkout seguro e acesso liberado após o pagamento.
            </p>

            <div style={styles.heroBtns}>
              <a href="#grafico" style={styles.primary}>Ver gráfico</a>
              <a href="#produtos" style={styles.secondary}>Ver produtos</a>
            </div>
          </div>

          <div id="demo" style={styles.videoCard}>
            <div style={styles.tabs}>
              <button
                onClick={() => setActiveDemo('emulador')}
                style={{
                  ...styles.tab,
                  background: activeDemo === 'emulador' ? '#22d3ee' : 'rgba(255,255,255,0.07)',
                  color: activeDemo === 'emulador' ? '#020617' : '#fff'
                }}
              >
                🎮 Emulador
              </button>

              <button
                onClick={() => setActiveDemo('mobile')}
                style={{
                  ...styles.tab,
                  background: activeDemo === 'mobile' ? '#22d3ee' : 'rgba(255,255,255,0.07)',
                  color: activeDemo === 'mobile' ? '#020617' : '#fff'
                }}
              >
                📱 Mobile
              </button>
            </div>

            <motion.div key={activeDemo} initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.35 }} style={styles.iframeBox}>
              <iframe
                src={
                  activeDemo === 'emulador'
                    ? 'https://drive.google.com/file/d/1SYKPTJ7kbPsko8C8S1wyuKjc1Zd0jQ_N/preview'
                    : 'https://drive.google.com/file/d/1Lp040AWBH-ztcK7-l-vogSISExNnQZRj/preview'
                }
                title="Demonstração"
                allow="autoplay"
                style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', border: 'none' }}
              />
            </motion.div>

            <div style={{ ...styles.offerCard, marginTop: 14 }}>
              <strong>{productAtual.titulo}</strong>
              <div style={{ color: '#22d3ee', fontSize: 24, fontWeight: 950, marginTop: 6 }}>
                R$ {productAtual.preco.toFixed(2).replace('.', ',')}
              </div>
              <a href={productAtual.lastlink} target="_blank" rel="noreferrer" style={styles.buy}>
                Comprar essa config
              </a>
            </div>
          </div>
        </section>

        <h2 id="grafico" style={styles.sectionTitle}>Gráfico Massinha AMD</h2>

        <section style={styles.graphSection}>
          <div>
            <CompareImage />
          </div>

          <div style={styles.graphInfo}>
            <span style={styles.tag}>💎 Mais vendido</span>
            <h3 style={styles.productTitle}>Gráfico Massinha AMD</h3>

            <p style={{ color: '#cbd5e1', lineHeight: 1.7, marginTop: 10 }}>
              Veja a diferença entre o jogo normal e com o gráfico massinha aplicado.
              Visual mais limpo, configuração leve e entrega automática pela Lastlink.
            </p>

            <div style={styles.price}>R$ 5,00</div>

            <a href={grafico.lastlink} target="_blank" rel="noreferrer" style={styles.buy}>
              Comprar Gráfico Massinha
            </a>
          </div>
        </section>

        <h2 id="produtos" style={styles.sectionTitle}>Escolha seu produto</h2>

        <div style={styles.grid}>
          {products.map((produto) => (
            <ProductCard key={produto.id} produto={produto} />
          ))}
        </div>

        <div style={{ ...styles.proof, marginTop: 34 }}>
          <div style={styles.proofBox}>
            <strong>⚡ Entrega automática</strong>
          </div>
          <div style={styles.proofBox}>
            <strong>🛡️ Checkout seguro pela Lastlink</strong>
          </div>
          <div style={styles.proofBox}>
            <strong>🎮 Config pronta para usar</strong>
          </div>
        </div>

        <div style={styles.footer}>
          Loja MacroX FF © • Compra segura via Lastlink
        </div>
      </div>
    </div>
  );
}